/* This is used by NAVIGATION */
import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'

type Props = {
  closeModal: () => void
  startPosition: number
  showModal: boolean
}

const Modal = (props: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const GalleryModal = dynamic(
    import(
      /* webpackChunkName: "artwork" */
      './Modal'
    ),
    noSSR
  )
  const { showModal, closeModal, startPosition } = props
  return (
    <GalleryModal closeModal={closeModal} startPosition={startPosition} showModal={showModal} />
  )
}

const Component: FC<Props> = (props) => {
  const { showModal } = props

  if (!showModal) {
    return null
  }

  return <Modal {...props} />
}

export default Component
